import { DataTableQueryContextProvider } from "@/components/data-table/DataTableQueryContext";
import { List } from "@/components/list/List";
import { ContractorsPlannedHoursWizardListSection } from "@/modules/contractorsPlannedHoursWizard/components/ContractorsPlannedHoursWizardListSection";
import {
  CONTRACTORS_PLANNED_HOURS_WIZARD_RESULTS_TABLE,
  useContractorsPlannedHoursWizardResultsQuery,
} from "@/modules/contractorsPlannedHoursWizard/hooks/useContractorsPlannedHoursWizardResultsQuery";
import { displayContractorsPlannedHoursWizardResult } from "@/schemas/contractorsPlannedHoursWizard";
import {
  DisplayContractorsPlannedHoursWizardResult,
  ReadContractorsPlannedHoursWizardResult,
} from "@/types/contractorsPlannedHoursWizard";

interface ContractorsPlannedHoursWizardResultsPanelProps {
  results: ReadContractorsPlannedHoursWizardResult[];
}

export function ContractorsPlannedHoursWizardResultsPanel({
  results,
}: ContractorsPlannedHoursWizardResultsPanelProps) {
  const { options, query, queryValue, resultsTableFeatures } =
    useContractorsPlannedHoursWizardResultsQuery(results);

  return (
    <List<DisplayContractorsPlannedHoursWizardResult>
      schema={displayContractorsPlannedHoursWizardResult}
      name={CONTRACTORS_PLANNED_HOURS_WIZARD_RESULTS_TABLE}
      translationKey="contractorsPlannedHoursWizard"
      query={query}
      options={options}
      tableFeatures={resultsTableFeatures}
    >
      <DataTableQueryContextProvider value={queryValue}>
        <ContractorsPlannedHoursWizardListSection />
      </DataTableQueryContextProvider>
    </List>
  );
}
